import React, { useContext } from "react";
import classNames from "classnames";
// import Content from '../Content/Content';
import ThemeContext from "../../Contexts/themeContext";
import DefaultHeader from "./Header/DefaultHeader";
import Content from "./Content/Content";

export const WrapperContainer = ({ children, className, ...props }) => {
  const { rightPanel } = useContext(ThemeContext);
  return (
    <div
      className={classNames(
        "wrapper",
        { "wrapper-right-panel-active": rightPanel },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

const Wrapper = ({ children }) => {
  return (
    <>
      <WrapperContainer>
        <DefaultHeader />
        <Content children={children} />
      </WrapperContainer>
    </>
  );
};

export default Wrapper;
